import instance from "../utils/network";
import { StructuresResponse } from "../pages/tournament/hook/useEditTournament";

export interface ReservationRequest {
  cafeId: number;
  tournamentId: number;
  title: string;
  description: string;
  file: File;
  limitTime: string;
}

export interface ReservationResponse extends ReservationRequest {
  id: number;
  createAt: string;
  updatedAt: string;
  imageUrl: string;
}

export interface CurrentReservationResponse {
  reservationId: number;
  userId?: number;
  nickName: string;
  phoneNumber: string;
  root: string;
  id: number;
  createdAt: string;
  updatedAt: string;
  index: number;
  keepSeed?: number;
  reservationType?: CurrentReservationType;
}

export interface SellerReservationDto extends ReservationResponse {
  tournamentStart: string;
  tournamentStructure: StructuresResponse[];
  isSeedPay?: boolean;
}
export interface SellerReservationResponse extends ReservationResponse {
  data: SellerReservationDto[];
  total: number;
}

export enum CurrentReservationType {
  SEED = "SEED",
  POINT = "POINT",
  NORMAL = "NORMAL",
}

export interface ReservationTournamentResponse {
  id: number;
  memberId: number;
  nickname: string;
  phoneNumber: string;
  createdAt: string;
  updatedAt: string;
  isSitin: boolean;
  keepSeed?: number;
  keepPoint?: number;
  type?: CurrentReservationType;
}

export function registerReservation(
  request: FormData
): Promise<{ code: number; message: string }> {
  return instance.post("/seller/reservation/create", request, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function editReservation(
  id: number,
  request: FormData
): Promise<{ code: number; message: string }> {
  return instance.put(`/seller/reservation/update/${id}`, request, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function getMyReservation(
  pubId: number,
  page: number
): Promise<SellerReservationResponse> {
  return instance.get(`/seller/reservation/pub/${pubId}?page=${page}&limit=10`);
}

export function getCurrentReservationById(
  id: number
): Promise<CurrentReservationResponse[]> {
  return instance.get(`/seller/reservation/current/${id}`);
}

export function removeReservations(
  ids: number[]
): Promise<{ code: number; message: any }> {
  return instance.delete(`/seller/reservation/list`, {
    data: ids,
  });
}

export function cancelUserReservation(
  id: number
): Promise<{ code: number; message: any }> {
  return instance.delete(`/seller/reservation/user-cancel/${id}`);
}

export function getCurrentReservationByTournamentId(id: number): Promise<{
  code: number;
  message: any;
  payload: ReservationTournamentResponse[];
}> {
  return instance.get(`/seller/reservation/current-tournament/${id}`);
}
